import BaseService from './baseService'

import { useAppStore } from '@/store/app'

import { VueCookies } from 'vue-cookies'
import { apiMethods } from '@/api'
import { User } from '@/types/user'
import {
  SendLoginOtpResponse,
  ValidateOtpRequest,
  ValidateOtpResponse
} from '@/types/authServiceTypes'

class AuthService extends BaseService {
  constructor() {
    super()
  }
  enableTwoFactorLogin = async () => {
    const response = await this.apiClient.get(
      'authentication/enableTwoFactorLogin'
    )
    return response
  }

  disableTwoFactorLogin = async () => {
    await this.apiClient.post('authentication/disableTwoFactorLogin')
  }

  resendOtp = async () => {
    const response = await this.apiClient.get('authentication/resendOtp', {
      type: 'verification'
    })
    return response
  }

  verfiyOtp = async (otp: string) => {
    const response = await this.apiClient.post(
      'authentication/enableTwoFactorLogin',
      {
        otp: otp
      }
    )
    return response
  }

  resetPassword = async (
    userId: number | undefined,
    currentPassword: string,
    newPassword: string
  ) => {
    await this.apiClient.post(`users/${userId}/resetPassword`, {
      currentPassword,
      newPassword
    })
  }

  clearAuthData = async (cookies: VueCookies) => {
    const appStore = useAppStore()
    const portalDomain =
      import.meta.env.MODE === 'development'
        ? ('localhost' as string)
        : (appStore.getPortalDomain as string)
    localStorage.removeItem('accessToken')
    cookies.remove('user', undefined, portalDomain)
    cookies.remove('accessToken', undefined, portalDomain)
  }

  addAuthData = async (
    cookies: VueCookies,
    user: User | null,
    accessToken: string | null
  ) => {
    const appStore = useAppStore()
    const portalDomain =
      import.meta.env.MODE === 'development'
        ? ('localhost' as string)
        : (appStore.getPortalDomain as string)

    cookies.set(
      'accessToken',
      accessToken ? { accessToken } : null,
      undefined,
      undefined,
      portalDomain
    )

    if (accessToken) {
      localStorage.setItem('accessToken', accessToken)
    } else {
      localStorage.removeItem('accessToken')
    }

    cookies.set('user', user, undefined, undefined, portalDomain)
  }

  sendLoginOtp = async (
    emailAddress: string,
    otpChannels: number[]
  ): Promise<SendLoginOtpResponse> => {
    const payload = {
      portal: useAppStore().getPortalDomain,
      emailAddress,
      otpChannels
    }

    const response = await this.apiClient.post<SendLoginOtpResponse>(
      'authentication/sendLoginOtp',
      payload
    )
    return response
  }

  validateOtpFromSignup = async (
    validateOtpData: ValidateOtpRequest
  ): Promise<{ data: ValidateOtpResponse }> => {
    validateOtpData.clientId = import.meta.env.VITE_APP_DELTAX_CLIENT_APP_ID
    validateOtpData.portal = useAppStore().getPortalDomain

    const response = await this.apiClient.post<{ data: ValidateOtpResponse }>(
      'authentication/ValidateOtpFromSignup',
      validateOtpData,
      {},
      true
    )
    return response
  }

  logout = async () => {
    await apiMethods.logout()
  }
}

export default AuthService
